import { ONLY_IN_STOCK_FIELD, ONLY_IN_STOCK_OPTIONS, ONLY_IN_STORE_FIELD } from "../models/constants/only-in-stock.constant";
import { PAGINATION_SIZE } from "../models/constants/shared.constant";
import { OnlyInStock } from "../models/enums/OnlyInStock.enum";
import { Filter, Filters, ProductsBodyPayload } from "../models/types/Filters.type";
import { Products } from "../models/types/Product/Product.type";
import { ProductDTO } from "../models/types/Product/ProductDTO.type";

export class ProductList implements ProductDTO {

  private _count: number;
  private _size: number;
  private _page: number;
  private _pages: number;
  private _groups: string[];
  private _groupIndexes: number[];
  private _items: Products;
  private _filters: Filters;

  constructor() {
    this._count = 0;
    this._size = PAGINATION_SIZE;
    this._page = 1;
    this._pages = 1;
    this._groups = [];
    this._groupIndexes = [];
    this._items = [];
    this._filters = [];
  }

  get count(): number { return this._count; }

  get size(): number { return this._size; }

  get page(): number { return this._page; }

  get pages(): number { return this._pages; }

  get groups(): string[] { return this._groups; }

  get groupIndexes(): number[] { return this._groupIndexes; }

  get items(): Products { return this._items; }

  get filters(): Filters { return this._filters; }

  get bodyPayload(): ProductsBodyPayload {
    return {
      page: this.page,
      size: this.size,
      filters: this.filters
    }
  }

  get searching(): boolean {
    if (this._filters) {
      const fiedlsToExclude = [ONLY_IN_STOCK_FIELD, ONLY_IN_STORE_FIELD];
      return this._filters.filter(f => {
        return !fiedlsToExclude.includes(f.field);
      }).length > 0;
    }
    return false;
  }

  get isEmpty(): boolean {
    return this.count === 0 || this.items.length === 0;
  }

  get canLoadAnotherPage(): boolean {
    return (this._page < this._pages);
  }

  update(data: ProductDTO) {
    this._count = data.count;
    this._pages = Math.ceil(this._count / this._size);
    this._groups = data.groups;

    this.updateGroupIndexes(data.items);

    // if (this.searching) {
    //   this.setProducts(data.items);
    // } else {
    this.addProducts(data.items);
    // }

  }

  reset() {
    this._count = 0;
    this._size = PAGINATION_SIZE;
    this._page = 1;
    this._pages = 1;
    this._groups = [];
    this._groupIndexes = [];
    this._items = [];
    this._filters = [];
  }

  setProducts(products: Products) {
    this._items = products;
  }

  addProducts(products: Products) {
    this._items = this._items.concat(products);
  }

  skipToNextPage() {
    if (this.canLoadAnotherPage) {
      this._page += 1;
    }
  }

  setFilters(filters: Filters) {
    this.reset();
    // //Resetto i filtri lasciando il filtro di OnlyInStock o OnlyInStore
    // const fiedlsToExclude = [ONLY_IN_STOCK_FIELD, ONLY_IN_STORE_FIELD];
    // filters = filters.filter(f => fiedlsToExclude.includes(f.field));
    this._filters = filters;
  }

  /**
   * Aggiorno gli indici in cui inserire i titoli dei gruppi dei prodotti
   * @param products
   */
  updateGroupIndexes(products: Products) {
    //Salco l'indice di partenza in modo da non ciclare sempre tutti gli elementi dall'inizio
    let startIndex = this.items.length;
    let allProducts: Products = [];

    //Controllo se sto filtrando oppure paginando
    if (this.searching) {
      //Setto l'indice di partenza a 0
      startIndex = 0;
      //Setto i prodotti con quelli passati come parametro
      allProducts = [...products];
      //Resetto l'array degli indici dei gruppi
      this._groupIndexes = [];
    } else {
      //Setto i prodotti con la concatenazione dei prodotti esistenti con quelli da aggiungere (sto paginando)
      allProducts = [...this.items].concat([...products])
    }

    for (let i = startIndex; i < allProducts.length; i++) {
      //Appena trovo una differenza di gruppo mi salvo l'indice inserendolo nell'array dei gruppi
      if (i === 0 || allProducts[i].group !== allProducts[i - 1].group) {
        this._groupIndexes.push(i);
      }
    }
  }
}
